import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import Album from './Album';

const darkTheme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#a6d4fa'
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#f6a5c0',
      main: '#f48fb1',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00'
    },
    background: {
      default: '#202020',
      paper: '#303030'
    }
  }
});

function App() {
  return (
    <main>
      <Switch>
        <Route path="/" component={Album} />
      </Switch>
    </main>
  );
}

export default App;